import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../api';

export default function Signup() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const params = new URLSearchParams(window.location.search);
            const redirectTo = params.get('redirectTo');
            const response = await api.post('auth/signup/', { email, redirectTo });

            if (response.status === 200) {
                setSubmitted(true);
                toast.success(response.data.message);
            } else {
                // Axios errors typically have response.data.error
                toast.error(response.data.error || 'Failed to send signup email');
            }
        } catch (err) {
            // For network errors or non-2xx responses, err.response will contain details
            if (err.response && err.response.data && err.response.data.error) {
                toast.error(err.response.data.error);
            } else {
                toast.error('An error occurred. Please try again.');
            }
        }
    };

    if (submitted) {
        return (
            <div style={{ maxWidth: '400px', margin: '40px auto', textAlign: 'center' }}>
                <h2>Check Your Inbox</h2>
                <p>We have sent a verification link to <strong>{email}</strong>.</p>
                <p>Please click the link in the email to set your PIN and complete signup.</p>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: '400px', margin: '40px auto' }}>
            <h2>Sign Up</h2>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Email Address</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{ width: '100%', padding: '8px' }}
                        placeholder="Enter your email"
                    />
                </div>
                <button type="submit" style={{ padding: '10px' }}>
                    Send Verification Link
                </button>
            </form>
        </div>
    );
}
